import React from 'react';
import VectorIcon from './VectorIcon';

type Props = {
  radius?: number;
  color?: string;
};

const CircleDeleteIcon = ({
  radius = 24,
  color = '#FFF',
}: Props): JSX.Element => (
  <VectorIcon width={radius} height={radius}>
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 9L9 15"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 9L15 15"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </VectorIcon>
);

export default CircleDeleteIcon;
